import React from "react";

import { getDataTestId } from "../../../utils/getDataTestId";
import { WSIcon, WSIconName, WSText } from "../core";
import { WSFlexBox } from "../layout/WSFlexBox/WSFlexBox.component";
import {
  WSElement,
  WSElementProps,
  WSElementSpacingsType
} from "../WSElement/WSElement.component";

import styles from "./WSCollapsible.module.scss";

export const DEFAULT_COLLAPSIBLE_SIZE: WSCollapsibleSize = "M";

export type WSCollapsibleSize = "S" | "M";

export type WSCollapsibleProps = WSElementProps & {
  title: string | React.ReactNode;
  size?: WSCollapsibleSize;
  icon?: WSIconName;
  name?: string;
};

const mapPadding: Record<WSCollapsibleSize, WSElementSpacingsType> = {
  S: "M",
  M: "XL"
};

export const WSCollapsible: React.FC<WSCollapsibleProps> = ({
  title,
  className,
  children,
  icon,
  size = DEFAULT_COLLAPSIBLE_SIZE,
  name,
  ...elementProps
}) => {
  const testIdBase = getDataTestId("collapsible", name, title);

  return (
    <WSElement
      as="details"
      className={styles.collapsible}
      data-testid={testIdBase}
      {...elementProps}
    >
      <WSElement
        as="summary"
        className={styles.summary}
        p={mapPadding[size]}
        data-testid={`${testIdBase}Trigger`}
      >
        <WSFlexBox.CenterY justify="space-between">
          <WSFlexBox.CenterY gap="S">
            {icon ? (
              <WSIcon
                name={icon}
                size={size}
                className={styles.icon}
                color="gray600"
              />
            ) : null}
            <WSText.ParagraphSm color="gray600" className={styles.title}>
              {title}
            </WSText.ParagraphSm>
          </WSFlexBox.CenterY>

          <WSIcon
            color="gray500"
            name="caret-down"
            size={size}
            className={styles.caret}
          />
        </WSFlexBox.CenterY>
      </WSElement>
      <WSElement
        p={mapPadding[size]}
        className={styles.content}
        data-testid={`${testIdBase}Content`}
      >
        {children}
      </WSElement>
    </WSElement>
  );
};
